/* eslint-disable no-shadow */
const state = {
	recommentedProduct: []
}

const getters = {
	getrecommendedProduct: state => state.recommentedProduct
}

const mutations = {
	setRecommentedProductDataMutation: (state, payload) => {
		// const products = JSON.parse(JSON.stringify(payload))
		state.recommentedProduct = payload
	},
	clearRecommendProductsDataMutation: (state) => {
		state.recommentedProduct = []
	}
}

const actions = {
	setRecommendedProductsData: ({
		commit
	}, payload) => {
		commit('setRecommentedProductDataMutation', payload)
	},
	clearRecommendProductsData: ({
		commit
	}, payload) => {
		commit('clearRecommendProductsDataMutation', payload)
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
